import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

const Sidebar = () => {
  const location = useLocation(); // Get the current location
  const [role, setRole] = useState(null);
  const [volunteerStatus, setVolunteerStatus] = useState(null);
  const [userRole, setUserRole] = useState("");

  const { state } = useAppContext();

  const handleToggleSidebar = () => {
    // Your toggle sidebar logic here
    window.clickToggleSidebarIcon();
    console.log("Sidebar toggled!");
  };

  // useEffect(() => {
  //   const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
  //   const is_volunteer = JSON.parse(localStorage.getItem("is_volunteer")); // Parses string "admin" to plain string

  //   setRole(role);
  //   setVolunteerStatus(is_volunteer);
  // }, []);

  // console.log("Role",state?.user?.role)
  // console.log("Volunteer status",state?.user?.is_volunteer)

  useEffect(() => {
    setUserRole(state?.user?.role);
    setVolunteerStatus(state?.user?.is_volunteer);
  }, []);

  // console.log("role",role)

  return (
    <div className="sidebar " id="main-sidebar" data-background-color="dark">
      <div className="sidebar-logo">
        <div className="logo-header" data-background-color="dark">
          <Link to="/blogs" className="logo">
            <img
              src="/logo.webp"
              alt="navbar brand"
              className="navbar-brand rounded-image"
              loading="lazy"
              height="60"
            />
          </Link>
          <div
            className="nav-toggle cursor-pointer "
            onClick={handleToggleSidebar}
          >
            <button className="btn btn-toggle toggle-sidebar">
              <i className="gg-menu-right"></i>
            </button>
            <button className="btn btn-toggle sidenav-toggler">
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
      </div>
      <div className="sidebar-wrapper position-relative scrollbar scrollbar-inner">
        <div className="sidebar-content">
          <ul className="nav nav-secondary">
            {/* {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/dashboard" ? "active" : ""
                }`}
              >
                <Link to="/user/dashboard">
                  <i className="fas fa-home"></i>
                  <p>Dashboard</p>
                </Link>
              </li>
            )} */}

            {/* {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/user/users" ? "active" : ""
                }`}
              >
                <Link to="/user/users">
                  <i className="fas fa-user"></i>
                  <p>Users</p>
                </Link>
              </li>
            )} */}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/blogs" ? "active" : ""
                }`}
              >
                <Link to="/blogs">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Blogs</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/media" ? "active" : ""
                }`}
              >
                <Link to="/media">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Media</p>
                </Link>
              </li>
            )}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/categories" ? "active" : ""
                }`}
              >
                <Link to="/categories">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Categories</p>
                </Link>
              </li>
            )}
            {/* {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/category/types" ? "active" : ""
                }`}
              >
                <Link to="/category/types">
                  <i className="fas fa-user"></i>
                  <p>Category Types</p>
                </Link>
              </li>
            )} */}

            {/* {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/news" ? "active" : ""
                }`}
              >
                <Link to="/news">
                  <i className="fas fa-user"></i>
                  <p>News</p>
                </Link>
              </li>
            )
            } */}

            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/locations" ? "active" : ""
                }`}
              >
                <Link to="/locations">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Location</p>
                </Link>
              </li>
            )}
            {userRole === "admin" && (
              <li
                className={`nav-item ${
                  location.pathname === "/transcript" ? "active" : ""
                }`}
              >
                <Link to="/transcript">
                  <i className="fas fa-user"></i>
                  {/* <p>Students</p> */}
                  <p>Transcript</p>
                </Link>
              </li>
            )}
            <li
              className={`nav-item ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              <Link to="/logout">
                <i className="fas fa-sign-out-alt"></i>
                <p>Logout</p>
              </Link>
            </li>
            {/* <li
              className={`nav-item ${
                location.pathname === "/user/account-settings" ? "active" : ""
              }`}
            >
              <Link to="/user/account-settings">
                <i className="fas fa-cog"></i>
                <p>Account Settings</p>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
